import React from "react";
import { Typography } from "antd";
import AppTable from "components/AppTable/AppTable";

const AccountTable = props => {
  const { dataSource, title, loading } = props;

  let columns = [
    {
      title: "Name",
      dataIndex: "name",
      ellipsis: true
    },
    {
      title: "E-Mail",
      dataIndex: "email",
      ellipsis: true,
      render: (text, record) => {
        return <Typography.Paragraph copyable>{text}</Typography.Paragraph>;
      }
    }
  ];

  return <AppTable title={title} columns={columns} dataSource={dataSource} loading={loading} scroll={scroll} bordered pagination={false} rowKey={record => record._id} />;
};

export default AccountTable;
